import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';

const NotFoundPage: React.FC = () => {
  const navigate = useNavigate();

  useEffect(() => {
    const redirectTimer = setTimeout(() => {
      navigate('/', { replace: true });
    }, 1500);

    return () => clearTimeout(redirectTimer);
  }, [navigate]);

  return (
    <div className="flex flex-col items-center justify-center min-h-screen bg-white dark:bg-gray-900 transition-colors duration-300">
      <div className="text-center p-8 max-w-md">
        <h1 className="text-4xl font-bold text-transparent bg-clip-text bg-gradient-to-r from-yellow-500 to-red-500 mb-4">
          Pàgina no trobada
        </h1>
        <p className="text-gray-600 dark:text-gray-300 mb-4">
          Redirigint a la pàgina principal...
        </p>
        <div className="w-full bg-gray-200 dark:bg-gray-700 rounded-full h-2.5 mb-4">
          <div className="bg-gradient-to-r from-yellow-500 to-red-500 h-2.5 rounded-full animate-progress"></div>
        </div>
      </div>
    </div>
  );
};

export default NotFoundPage;
